import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { PageHeader } from "../../components/common";
import { LucyFestivals } from "../../components/LucyFestivals";

const AlertsMoved = () => (
  <div className="ax-panel p-4 mb-4 text-sm" data-testid="alerts-moved">Reminder emails, event emails, pop-ups and sounds are now set in one place: <Link to="/admin/alerts" className="text-primary underline" data-testid="alerts-moved-link">Administration › Reminders &amp; Alerts</Link>.</div>
);

export default function AdminSettings() {
  const [cfg, setCfg] = useState(null);
  const [mand, setMand] = useState("");
  const [probs, setProbs] = useState("{}");
  const [stages, setStages] = useState([]);
  useEffect(() => { api.get("/orders/config").then((r) => { setProbs(JSON.stringify(r.data.stage_probabilities || {}, null, 1)); setStages(r.data.pre_po_stages); }).catch(() => {}); }, []);
  const saveProbs = () => {
    let sp;
    try { sp = JSON.parse(probs); } catch { toast.error("Probabilities must be valid JSON"); return; }
    api.put("/admin/orders-config", { stage_probabilities: sp }).then(() => toast.success("Stage probabilities saved")).catch((e) => toast.error(errMsg(e)));
  };
  useEffect(() => { api.get("/sales/config").then((r) => { setCfg(r.data); setMand(JSON.stringify(r.data.mandatory, null, 1)); }); }, []);
  if (!cfg) return null;
  const save = () => {
    let mandatory;
    try { mandatory = JSON.parse(mand); } catch { toast.error("Mandatory fields must be valid JSON"); return; }
    api.put("/admin/sales-config", { sources: cfg.sources, product_categories: cfg.product_categories, stale_days: Number(cfg.stale_days), mandatory })
      .then((r) => { setCfg(r.data); toast.success("Settings saved"); }).catch((e) => toast.error(errMsg(e)));
  };
  const list = (k, label) => (
    <label className="text-xs block"><span className="ax-label">{label} (one per line)</span>
      <textarea data-testid={`settings-${k}`} value={cfg[k].join("\n")} onChange={(e) => setCfg({ ...cfg, [k]: e.target.value.split("\n") })} className="mt-1 w-full h-40 bg-muted/60 border p-2 text-sm font-mono" /></label>
  );
  return (
    <div>
      <PageHeader eyebrow="Configuration" title="Sales settings" desc="Set dropdown values, which fields each stage requires and the inactivity threshold. Status codes A–G are kept exactly as in your Sales Tracker." />
      <AlertsMoved />
      <LucyFestivals />
      <div className="grid md:grid-cols-2 gap-4 ax-panel p-4">
        {list("sources", "Lead sources")}
        {list("product_categories", "Product categories")}
        <label className="text-xs block"><span className="ax-label">Required fields by status code</span>
          <textarea data-testid="settings-mandatory" value={mand} onChange={(e) => setMand(e.target.value)} className="mt-1 w-full h-40 bg-muted/60 border p-2 text-sm font-mono" /></label>
        <label className="text-xs block"><span className="ax-label">Inactivity alert after (days)</span>
          <input data-testid="settings-stale-days" type="number" value={cfg.stale_days} onChange={(e) => setCfg({ ...cfg, stale_days: e.target.value })} className="mt-1 w-full bg-muted/60 border h-9 px-2 text-sm" />
          <div className="mt-4 ax-label">Statuses</div>{cfg.statuses.map((s) => <div key={s.code} className="text-sm">{s.label} {s.open ? "· open" : "· closed"}</div>)}</label>
      </div>
      <button data-testid="settings-save" onClick={save} className="mt-4 bg-primary text-primary-foreground h-9 px-6 text-sm">Save settings</button>
      <div className="ax-panel p-4 mt-8" data-testid="orders-probabilities">
        <div className="ax-label mb-1">Order Management · win probability (%) by Pre-PO stage</div>
        <p className="text-xs text-muted-foreground mb-2">Used for the weighted forecast. Your sheets don't define these, so they start empty. Enter your own, e.g. {"{\"K-Costing/TVC/BOQ\": 40}"}. Stages: {stages.join(" · ")}</p>
        <textarea data-testid="settings-probabilities" value={probs} onChange={(e) => setProbs(e.target.value)} className="w-full h-40 bg-muted/60 border p-2 text-sm font-mono" />
        <button data-testid="settings-probabilities-save" onClick={saveProbs} className="mt-2 bg-primary text-primary-foreground h-9 px-6 text-sm">Save probabilities</button>
      </div>
    </div>
  );
}
